export default __webpack_public_path__ + "static/top40-f03567426930448b44b672581fed3946.png";